import { render, staticRenderFns } from "./view__list.vue?vue&type=template&id=6365f100"
import script from "./view__list.vue?vue&type=script&lang=js"
export * from "./view__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports